module.exports = __webpack_public_path__ + "img/papel-higienico-mobile.be45c2b0.png";